import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Event as EventService } from '../services/event';
import { NetworkService } from '../services/network';

export const managerGuard: CanActivateFn = async (route) => {
  const eventService = inject(EventService);
  const router = inject(Router);
  const network = inject(NetworkService);

  const eventId = route.paramMap.get('eventId');
  if (!eventId) return router.createUrlTree(['/home']);

  try {
    const isManager = await eventService.isManager(eventId);
    return isManager ? true : router.createUrlTree([`/events/${eventId}`]);
  } catch {
    if (!network.isOnline()) return true;
    return router.createUrlTree([`/events/${eventId}`]);
  }
};
